<template>
	<div>
	<h1 class="mw-h1">{{organisation.name}}</h1>
	<v-card >
			
		<v-tabs
			v-model="tab"
			background-color="white"
			color="black"
			right 
			show-arrows
			pagination
			:icons-and-text="true"
		>
			<v-tabs-slider></v-tabs-slider>

			<v-tab href="#infoTab">
				Organisation Info <v-icon>mdi-information</v-icon>
			</v-tab>
			<v-tab href="#settingsTab">
				Organisation Settings<v-icon>mdi-cog</v-icon>
			</v-tab>
			<v-tab href="#requestTab">
				Requests <v-icon>mdi-file-plus-outline</v-icon>
			</v-tab>
			<v-tab href="#contactTab">
				Contacts <v-icon>mdi-account</v-icon>
			</v-tab>
			<v-tab href="#projectTab">
				Projects <v-icon>mdi-folder-information</v-icon>
			</v-tab>
			<v-tab href="#contractTab">
				Contracts <v-icon>mdi-signature</v-icon>
			</v-tab>
			<v-tab href="#invoiceTab">
				Invoices <v-icon>mdi-receipt</v-icon>
			</v-tab>
			<v-tab href="#notesTab">
				Notes<v-icon>mdi-notebook</v-icon>
			</v-tab>
			<v-tab-item value="settingsTab">
				<EditOrganisationSettings :organisation="organisation" v-on:save="save"></EditOrganisationSettings>				
			</v-tab-item>
			<v-tab-item value="infoTab">
				<v-sheet class="pa-4">
					<v-text-field
						v-model="organisation.name"
						label="Organisation Name"
						required
					></v-text-field>	  
					<v-textarea
						label="Description"
						v-model="organisation.description"
					></v-textarea>
					<v-row>
						<v-col>
							<v-textarea
								v-model="organisation.addresss"
								label="Street Address"
							></v-textarea>	  
						</v-col>
						<v-col>
							<v-text-field
								v-model="organisation.postcode"
								label="Postcode"
							></v-text-field>	 
							<v-text-field
								v-model="organisation.phone"
								label="Main Phone Number"
							></v-text-field>	  
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<v-text-field
								v-model="organisation.email"
								label="Contact Email"
								prepend-icon="mdi-email"
							></v-text-field>	  
						</v-col>
						<v-col>
							<v-text-field
								v-model="organisation.twitter"
								label="Twitter Handle"
								prepend-icon="mdi-twitter"
							></v-text-field>	  
						</v-col>
						<v-col>
							<v-text-field
								v-model="organisation.url"
								prepend-icon="mdi-earth"
								label="Website"
							></v-text-field>	  
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<UploadField 
							v-if="organisation.id"
							accept="image/*" 
							:exists="initialLogo !==  false"
							:folderStem="logoFolderPath"
							:fileName="logoFileName"
							label="Client Logo"
							description="Upload a logo for this client to customise the experience of their users. Recommended resolution A x B"
							v-on:complete="changeLogo"
							></UploadField>
						</v-col>
						<v-col v-if="initialLogo" cols="12" sm="2">
							<img :src="initialLogo" width="170px" />
						</v-col>
					</v-row>
					<v-btn
					color="success"
					class="mr-4 ml-3 mb-3"
					@click="save"
					>Save
					</v-btn>
				</v-sheet>
			</v-tab-item>
			<v-tab-item value="contractTab">
				<EditOrganisationContracts :organisation="organisation" v-on:saved="$emit('saved')"></EditOrganisationContracts>
			</v-tab-item>
			<v-tab-item value="invoiceTab">
				<EditOrganisationInvoices :organisation="organisation" v-on:save="save"></EditOrganisationInvoices>
			</v-tab-item>
			<v-tab-item value="contactTab">
				<v-card class="pa-4">
					<ListSubpanel name=" " :rows="clients" :headers="userHeaders" class="mt-5" editLink="/edit/clients/"></ListSubpanel>
				</v-card>
			</v-tab-item>
			<v-tab-item value="projectTab">
				<v-card class="pa-4">
					<ListSubpanel name=" " :rows="projects" :headers="projectHeaders" class="mt-5" editLink="/edit/projects/" v-on:created="fetchProjects"></ListSubpanel>
				</v-card>
			</v-tab-item>
			<v-tab-item value="requestTab">
				<v-sheet flat class="pa-4">
					<AdminList type="requests" :items="requests"></AdminList>
				</v-sheet>
			</v-tab-item>
			<v-tab-item value="notesTab">
				<v-card flat tile class="pb-5">
					<EditObjectNotes class="mb-5 pb-5" :object="organisation" v-on:save="save"></EditObjectNotes>
				</v-card>
			</v-tab-item>
		</v-tabs>

	</v-card >
		</div>
</template>

<script>
import Vuex from 'vuex'

import UploadField from "../tools/UploadField.vue";
import EditOrganisationContracts from "../edits/EditOrganisationContracts.vue";
import AdminList from "../AdminList.vue";
import {getFileFromStorage}   from "../../assets/storageFunctions.js";
export default {
  name: 'EditOrganisation',
  props: ["organisation"],
  components: {
	EditObjectNotes: () => import('../edits/EditObjectNotes'),
	UploadField: UploadField,
	EditOrganisationContracts: EditOrganisationContracts,
	EditOrganisationInvoices: () => import('../edits/EditOrganisationInvoices'),
	EditOrganisationSettings: () => import('../edits/EditOrganisationSettings'),
	ListSubpanel: () => import('../subpanels/ListSubpanel.vue'),
	AdminList: AdminList
  },	
  data: () => ({
		tab: 'infoTab',
		initialLogo: false,
		userHeaders: [
			{ text: "Name", value: "displayName"},
			{ value: "linkTo", text: "" }
		],
		projectHeaders: [
			{ text: "Name", value: "internalName"},
			{ text: "Live", value: "active"},
			{ value: "linkTo", text: "" }
		]
    }),
	computed:{
		...Vuex.mapState({
			view: state => state.auth.view,
			requests(state){
				let organisation = this.organisation.id; 
				return state.admin.requests.filter( s => s.organisation == organisation )
			},
			clients(state){
				let organisation = this.organisation.id; 
				return state.admin.clients.filter( c => c.organisation == organisation )
			},
			projects(state){
				let organisation = this.organisation.id; 
				return state.admin.projects.filter( p => p.client == organisation )
			}
		}),
		logoFileName(){
			return this.organisation.id + '.jpg'
		},
		logoFolderPath(){
			return "logos"
		},
		logoPath(){
			return this.logoFolderPath + "/" + this.logoFileName
		},
	},
	watch: {
		logoPath: {
			immediate: true,
			handler(){
				const self = this;
				if( self.organisation.id ){
					getFileFromStorage(self.logoPath).then( url => {
						self.initialLogo = url;
					})
				}
			}
		}
	},
	created(){
		if( !this.organisation.id ){ return; }
		this.$store.dispatch("fetchOrganisation", this.organisation.id)
	},
	methods: {
		fetchProjects(){
			this.$store.dispatch("fetchOrganisationProjects", this.organisation.id);
		},
		changeLogo(child){
			const self = this;
			child.ref.getDownloadURL().then( url => {
				self.initialLogo = url;
			})
		},
		save() {
			var self = this;
			let update = {};
			for( var key in self.organisation ){
				update[key] = self.organisation[key];	
			}			

			self.$store.dispatch("updateDoc", {
				action: "update",
				data: update,
				doc: "organisations/"+self.organisation.id
			}).then( () => {
				self.$emit("saved");
			}) 
		}
	}
};

</script>
